import { ReactElement } from 'react';
import { LoadingGradient } from '@provider-directory/components/loading-gradient/loading-gradient.component';

export const CalendarSkeleton = (): ReactElement => (
  <LoadingGradient
    className={'flex flex-col gap-y-6 rounded-md pb-8 tablet:h-[43.8px]'}
  />
);

export const TimeSlotsSkeleton = (): ReactElement => (
  <div data-testid={'time-slots-skeleton'} className={'pt-8'}>
    <div className={'flex flex-col gap-y-6'}>
      <div className={'flex flex-col gap-y-[0.875rem]'}>
        <LoadingGradient className={'h-6 w-16 rounded-sm'} />
        <div className={'flex gap-x-2'}>
          <LoadingGradient className={'h-10 w-[6.25rem] rounded-full'} />
          <LoadingGradient className={'h-10 w-[6.25rem] rounded-full'} />
          <LoadingGradient className={'h-10 w-[6.25rem] rounded-full'} />
        </div>
      </div>
    </div>
  </div>
);
